import { render, staticRenderFns } from "./MarketsSummary.vue?vue&type=template&id=e3d1ae70&scoped=true&"
import script from "./MarketsSummary.vue?vue&type=script&lang=js&"
export * from "./MarketsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d1ae70",
  null
  
)

export default component.exports